import { useState } from "react";

import ENV from "config/Env";
import { usePermanentRealTimeUser, useTypedMutation } from "hooks";
import { ApiInstance } from "utils/Api";

import type { Article } from "models";
import type { CreateArticleFormValues } from "modules/NewsDashboard/components/ArticleModal/ArticleForm";

export const useCreateArticleMutation = () => {
  const { user } = usePermanentRealTimeUser();
  const [hasValidationErrors, setHasValidationErrors] = useState(false);

  const validateArticle = (article: CreateArticleFormValues) => {
    const hasErrors = !article.title || (!article.location_ids.length && !article.dealer_ids.length && !article.visible_to_all) || !article.selector || !article.content;
    setHasValidationErrors(hasErrors);
    return hasErrors;
  };

  const { mutateAsync, isPending } = useTypedMutation<Article, void>({
    mutationFn: async formData => {
      await ApiInstance.post("/articles/create", { ...formData, user: { first_name: user?.first_name, last_name: user?.last_name } }, ENV.dealerBaseURL);
    },
    onSuccess: () => null
  });

  return { createArticleMutation: mutateAsync, isPending, validateArticle, hasValidationErrors };
};
